import type React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { ProductDetailsGeneralTabV3 } from './tabs/general/general';
import { ProductDetailsShippingDefaultsV3 } from './tabs/shipping-defaults/shipping-defaults';
import { ProductDetailsCustomsDeclarationsV3 } from './tabs/customs-declarations/customs-declarations';
import { ProductDetailsInventoryV3 } from './tabs/inventory/inventory';
import { ProductDetailsAliasesV3 } from './tabs/aliases/aliases';
import { ProductDetailsActivityV3 } from './tabs/activity/activity';
import { ProductDetailsLocationsV3 } from './tabs/locations/locations';
import { ProductDetailsAdminV3 } from './tabs/admin/admin';
import { ProductDetailsUnitOfMeasureV3 } from './tabs/uom/uom';
import { messages } from '../messages';

type DrawerTabAdditionalSettings = {
  isSmartRoutingEnabled: boolean;
  isUnitsOfMeasureLdEnabled: boolean;
};

type DrawerTabRenderContext = {
  isSysAdmin: boolean;
};

type DrawerTab = {
  id: string;
  name: () => React.ReactNode;
  render: () => React.ReactNode;
  shouldRender: (context: DrawerTabRenderContext, additionalSettings: DrawerTabAdditionalSettings) => boolean;
};

export const DRAWER_TABS_V3: DrawerTab[] = [
  {
    id: 'general',
    name: () => <Text textType={TextType.Paragraph} value={messages.generalTab} />,
    render: () => <ProductDetailsGeneralTabV3 />,
    shouldRender: () => true,
  },
  {
    id: 'shipping-defaults',
    name: () => <Text textType={TextType.Paragraph} value={messages.shippingTab} />,
    render: () => <ProductDetailsShippingDefaultsV3 />,
    shouldRender: () => true,
  },
  {
    id: 'customs-declarations',
    name: () => <Text textType={TextType.Paragraph} value={messages.customsTab} />,
    render: () => <ProductDetailsCustomsDeclarationsV3 />,
    shouldRender: () => true,
  },
  {
    id: 'product-inventory',
    name: () => <Text textType={TextType.Paragraph} value={messages.productInventoryTab} />,
    render: () => <ProductDetailsInventoryV3 />,
    shouldRender: () => true,
  },
  {
    id: 'product-location',
    name: () => <Text textType={TextType.Paragraph} value={messages.productLocationsTab} />,
    render: () => <ProductDetailsLocationsV3 />,
    shouldRender: (_, { isSmartRoutingEnabled }) => isSmartRoutingEnabled,
  },
  {
    id: 'product-aliases',
    name: () => <Text textType={TextType.Paragraph} value={messages.storeAliasTab} />,
    render: () => <ProductDetailsAliasesV3 />,
    shouldRender: () => true,
  },
  {
    id: 'product-units-of-measure',
    name: () => <Text textType={TextType.Paragraph} value={messages.unitsOfMeasureTab} />,
    render: () => <ProductDetailsUnitOfMeasureV3 />,
    shouldRender: (_, { isUnitsOfMeasureLdEnabled }) => isUnitsOfMeasureLdEnabled,
  },
  {
    id: 'product-activity',
    name: () => <Text textType={TextType.Paragraph} value={messages.productActivity} />,
    render: () => <ProductDetailsActivityV3 />,
    shouldRender: () => true,
  },
  {
    id: 'admin',
    name: () => <Text textType={TextType.Paragraph} value={messages.adminTab} />,
    render: () => <ProductDetailsAdminV3 />,
    shouldRender: ({ isSysAdmin }) => isSysAdmin,
  },
];
